module.exports = __webpack_public_path__ + "img/arrow-left-bold.e377e0b6.svg";